export const localeAppSettings = { language: "en-US", locale: "en" };
export const localeEnUS = "en-US";
